import useSWR from "swr";
import * as eComProductAPI from "../services/eComProduct";
import { BillingPlan } from "../types/model/eComProduct";

export function useBillingPlans() {
  const { data, error, isLoading, mutate } = useSWR<BillingPlan[]>(
    "billing-plans",
    () => eComProductAPI.fetchBillingPlans(),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 60000,
    }
  );

  return {
    billingPlans: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}
